import * as Routes from './constants.js';

const routes = {
	casino: Routes.ROUTE_CASINO_EXPLORE,
	livecasino: Routes.ROUTE_LIVE_CASINO_EXPLORE,
	explore: Routes.ROUTE_CASINO_EXPLORE,
	livebetting: Routes.ROUTE_LIVEBETTING,
	sportsbook: Routes.ROUTE_SPORTSBOOK
};

export default routes;
